import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { AddDeviceFacilityComponent } from "./add-device-facility/add-device-facility.component";
import { DevicesComponent } from "./devices.component";

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: DevicesComponent
    },
    {
      path: 'add-device-facility',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: AddDeviceFacilityComponent
    },
    {
      path: 'edit-device/:id',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.ManageDevices},
      component: AddDeviceFacilityComponent
    }
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class DevicesRoutingModule { }
  